import request from "@/utils/request";

export function getMesWorkorderListApi(params) {
  return request({
    url: "?c=mes&a=workorder&do=list",
    method: "get",
    params
  });
}

export function getMesWorkorderApi(params) {
  return request({
    url: "?c=mes&a=workorder&do=get",
    method: "get",
    params
  });
}

export function preWorkorderNoApi(params) {
  return request({
    url: "?c=mes&a=workorder&do=precreate",
    method: "get",
    params
  });
}

export function postMesWorkorderApi(data) {
  return request({
    url: "?c=mes&a=workorder&do=post",
    method: "post",
    data
  });
}

export function importMesWorkorderApi(data) {
  return request({
    url: "?c=mes&a=workorder&do=import",
    method: "post",
    data
  });
}

export function exportMesWorkorderApi(data) {
  return request({
    url: "?c=mes&a=workorder&do=export",
    method: "post",
    data
  });
}

export function delMesWorkorderApi(data) {
  return request({
    url: "?c=mes&a=workorder&do=del",
    method: "post",
    data
  });
}

export function sendMesWorkorderApi(data) {
  return request({
    url: "?c=mes&a=workorder&do=send",
    method: "post",
    data
  });
}

export function workorderPauseApi(data) {
  return request({
    url: "?c=mes&a=workorder&do=pause",
    method: "post",
    data
  });
}

export function workorderFlowApi(params) {
  return request({
    url: "?c=mes&a=flow&do=getall",
    method: "get",
    params
  });
}

export function workorderLogsApi(params) {
  return request({
    url: "?c=mes&a=workorder&do=getqclogs",
    method: "get",
    params
  });
}